var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"footer-navigation"},_vm._l((_vm.footerMenu.children),function(item){return _c('li',{key:item.id,staticClass:"footer-navigation__item"},[_c('a',{staticClass:"footer-navigation__action-link",attrs:{"href":item.url,"target":"_blank","rel":"noopener noreferrer"}},[_vm._v(_vm._s(item.title))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }